import { tokenApi } from './token.api';

export async function fetchServerSideToken(clientSideToken: string, scope: string): Promise<string> {
    try {
        // Call the API to generate the OBO token
        const response = await tokenApi.getOboToken(clientSideToken, scope);

        // Validate the response
        if (!response || !response.oboToken) {
            const errorMessage = 'Invalid response from backend: missing "oboToken"';
            console.error(errorMessage);
            throw new Error(errorMessage);
        }

        // Return the OBO token
        return response.oboToken;
    } catch (error) {
        // Log and rethrow the error
        console.error('Error in fetchServerSideToken:', error);
        throw error;
    }
}